<template>
  <div>
    <app-date/>
    <hr>
    <app-confreres/>
    <hr>
    <app-ajout-filtre/>
  </div>
</template>

<script>
import filtreDate from './date';
import AjoutFiltre from './ajoutFiltre';
import confreres from './confreres';

export default {
  name: 'filtres',
  components: {
    appDate: filtreDate,
    appAjoutFiltre: AjoutFiltre,
    appConfreres: confreres,
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxNumerique/filtres/filtresPatrimoine.vue